/* eslint-disable no-param-reassign */
import * as MutationTypes from '@/store/mutation-types';
import { assignHelper } from './helpers';

export default {
  [MutationTypes.OPEN_MENU](state) {
    state.menuOpened = true;
  },
  [MutationTypes.CLOSE_MENU](state) {
    state.menuOpened = false;
  },
  [MutationTypes.SET_CURRENT_OVERLAY_FILE]: assignHelper('currentOverlayFile'),
  [MutationTypes.OPEN_FILE_VIEWER](state) {
    state.fileViewerOpened = true;
  },
  [MutationTypes.CLOSE_FILE_VIEWER](state) {
    state.fileViewerOpened = false;
  },
  [MutationTypes.RESET](state) {
    state.opportunity.show = null;
    state.opportunity.list = [];
  },
  [MutationTypes.SET_ALERT]: assignHelper('alertMessage'),
  [MutationTypes.DISPLAY_KYC_BANNER](store) {
    store.banner.message = 'KYC Banner message';
    store.banner.button.title = 'Begin';
    store.banner.button.to = '/kyc';
  },
  [MutationTypes.DISPLAY_VALIDATED_KYC_BANNER](store) {
    store.banner.message = 'Validated KYC Banner message';
    store.banner.button.title = 'Begin';
    store.banner.button.to = '/kyc/validate';
  },
  [MutationTypes.RESET_BANNER](store) {
    store.banner.display = false;
  },
};
